export default __webpack_public_path__ + "static/media/title_loyalty.27ab006b.png";